<template>
    <v-content>
        <v-layout class="font-weight-bold">
            <v-flex shrink pt-2 v-if="label" style="font-weight: bold">
                <span class="mr-3">{{label}}</span>
            </v-flex>
            <v-flex>
                <v-menu
                        v-model="menu_date"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        transition="scale-transition"
                        offset-y
                        min-width="290px"
                        :disabled="disabled"
                >
                    <template v-slot:activator="{ on }">
                        <v-text-field
                                :hide-details="hideDetail"
                                v-model="model"
                                readonly
                                item-color="#3E7662"
                                color="#3E7662"
                                dense
                                v-on="on"
                                :disabled="disabled"
                        ></v-text-field>
                    </template>
                    <!--                    v-model="model"-->
                    <v-date-picker
                            @input="selectDateStart"
                            locale="th"
                            type="date"
                            color="#3E7662"
                            header-color="#3E7662"
                            :disabled="disabled"
                    ></v-date-picker>
                </v-menu>
            </v-flex>
        </v-layout>
    </v-content>
</template>

<script>
    export default {
        name: "DateInputForm",
        props: {
            model: {
                required: false
            },
            label: {
                type: String,
            },
            hideDetail: {
                type: Boolean,
            },
            disabled: Boolean,
        },
        data: () => ({
            menu_date: '',
        }),
        methods: {
            selectDateStart(val) {
                this.menu_date = false;
                //change date start
                let sub_year = val.substring(0,4);
                let sub_month = val.substring(5,7);
                let sub_day = val.substring(8,10);
                sub_year = parseInt(sub_year)+543;
                let changeDate = sub_day + '/' + sub_month + '/' + sub_year;
                let data = {
                    date: val,
                    changeDate: changeDate,
                }
                this.$emit("update-data", data);
            },
        }
    }
</script>
